<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-input v-model="search.nickName" placeholder="请输入微信名" @keyup.enter.native="load" style="width: 20%"
                clearable></el-input>
      <el-input v-model="search.roleId" placeholder="关联的角色ID" @keyup.enter.native="load" style="width: 20%"
                clearable></el-input>
      <el-button style="margin-left: 5px" @click="resetData">刷新</el-button>
      <el-button style="margin-left: 5px" @click="resetNotice">重置公告时间</el-button>
    </div>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="nickName"
          label="微信名">
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID">
        <template #default="{row}">
        <span
            class="copyable-text"
            @click="copyToClipboard(row.roleId)"
        >
          {{ row.roleId }}
          <i class="el-icon-document-copy"></i>
        </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="nextNoticeTime"
          label="下次公告时间">
      </el-table-column>

      <el-table-column label="操作" width="80px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!--新增编辑表单-->
    <el-dialog title="新增/编辑" v-model="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="账号名">
          <el-input v-model="form.nickName"></el-input>
        </el-form-item>
        <el-form-item label="权限">
          <el-select v-model="form.permission" filterable>
            <el-option
                v-for="item in permissionList"
                :key="item.id"
                :label="item.permission"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色ID">
          <el-input v-model="form.roleId"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'wechatUser',
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        createTime: '',
        nickName: '',
        permission: ''
      },
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      permissionList: [
        {id: 0, permission: '不认识的'},
        {id: 1, permission: '俱乐部成员'},
        {id: 2, permission: '网页脚本用户(内部)'},
        {id: 3, permission: '网页脚本用户(外部)'},
        {id: -1, permission: '未授权用户'},
        {id: 99, permission: '超级管理员'},
        {id: 100, permission: '网页脚本用户+超管'},
      ]
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
  },
  methods: {
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    save() {
      this.loading = true;
      if (this.form.id) {
        request.post("/wechatUser/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: res.msg
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.load()
          this.loading = false
          this.dialogVisible = false
        })
      }
    },

    resetData() {
      this.load()
    },
    resetNotice(){
      request.post("/wechatUser/resetNotice").then(res => {
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: res.msg
          })
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
        this.load()
        this.loading = false
        this.dialogVisible = false
      })
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/wechatUser/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    },
  }
}
</script>
